import React from 'react';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import CardContent from '@material-ui/core/CardContent';
import Tooltip from '@material-ui/core/Tooltip';
import Card from 'pages/Homepage/components/molecules/WidgetConfigCard';

interface Props {
  values: any;
  onSetFieldValue: (fieldKey: string, fieldValue: string) => void;
}

function MyTeamWidgetSettings({ values, onSetFieldValue }: Props) {
  const classes = useStyles();
  const managerTerminology = useSelector(state =>
    _get(state, ['client', 'terminology', 'teamLeader'], 'team leader'),
  ).toLowerCase();

  const managerTerminologyPlural = useSelector(state =>
    _get(state, ['client', 'terminology', 'teamLeader_plural'], 'team leaders'),
  ).toLowerCase();

  const dlrEnabled = useSelector(state =>
    _get(state, ['client', 'settings', 'dottedLineRelationships', 'enabled'], true),
  );

  const { displayTeammatesForLeader, displayDlrs } = values.settings;

  return (
    <>
      <Card>
        <CardContent>
          <div className={classes.content}>
            <div>
              <Typography variant="h5">
                Display people with the same {managerTerminology} if the person is a{' '}
                {managerTerminology} themselves?
              </Typography>
              <Typography variant="subtitle2">
                If you would like {managerTerminologyPlural} to only see people who report to them
                in the widget, and not those with the same {managerTerminology}, turn this setting
                off
              </Typography>
            </div>
            <Switch
              id="display-teammates-for-leader-switch"
              inputProps={{ 'aria-label': 'display teammates for leader switch' }}
              checked={displayTeammatesForLeader}
              onChange={() =>
                onSetFieldValue(
                  'settings.displayTeammatesForLeader',
                  // @ts-ignore
                  !displayTeammatesForLeader,
                )
              }
            />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Tooltip
            title={
              !dlrEnabled
                ? 'You must enable Dotted Line Relationships on your Settings page for this toggle to be available'
                : ''
            }
            placement="top"
            arrow
          >
            <div className={classes.content}>
              <div className={dlrEnabled ? '' : classes.disabled}>
                <Typography variant="h5">Display dotted line relationships?</Typography>
                <Typography variant="subtitle2">
                  If this is switched on, we will include dotted line relationships as part of a
                  person’s team within the widget
                </Typography>
              </div>
              <Switch
                id="display-dotted-line-relationships"
                inputProps={{ 'aria-label': 'display dotted line relationships' }}
                checked={dlrEnabled && displayDlrs}
                // @ts-ignore
                onChange={() => onSetFieldValue('settings.displayDlrs', !displayDlrs)}
                disabled={!dlrEnabled}
              />
            </div>
          </Tooltip>
        </CardContent>
      </Card>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  disabled: {
    color: theme.palette.text.disabled,
  },
}));

export default MyTeamWidgetSettings;
